import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaDropdown from './VaDropdown.vue'
export { default as VaDropdownContent } from './VaDropdownContent'

export default withConfigTransport(VaDropdown)
